import { useEffect, useState, useRef } from "react";

import { Formik, Form, Field, ErrorMessage } from "formik";

import { useNavigate } from "react-router-dom";

import { apiCall } from "../redux/api";

import { useAuth } from "../components/AuthProvider";
import whatsappImage from '../img-1.png'

import { toast } from 'react-toastify';
import SectionLoading from "../components/SectionLoading";

import ar from '../flags/ar.png'
import pe from '../flags/pe.png'
import bo from '../flags/bo.png'
import co from '../flags/co.png'
import ec from '../flags/ec.png'
import py from '../flags/py.png'
import uy from '../flags/uy.png'
import ve from '../flags/ve.png'
import cl from '../flags/cl.png'
import mx from '../flags/mx.png'

export const OnboardingFour = () => {

    const flags = [
        {
          idx: 1,
          name: "Argentina",
          src: ar,
          code: 549
        }, 
        {
          idx: 2,
          name: "Peru",
          src: pe,
          code: 519
        },
        {
          idx: 3,
          name: "Bolivia",
          src: bo,
          code: 591
        }, 
        {
          idx: 4,
          name: "Colombia",
          src: co,
          code: 579
        }, 
        {
          idx: 5,
          name: "Ecuador",
          src: ec,
          code: 5939
        },
        {
          idx: 6,
          name: "Paraguay",
          src: py,
          code: 5959
        },
        {
          idx: 7,
          name: "Uruguay",
          src: uy,
          code: 5989
        }, 
        {
          idx: 8,
          name: "Venezuela",
          src: ve,
          code: 5989
        }, 
        {
          idx: 9,
          name: "Chile",
          src: cl,
          code: 569
        },
        {
          idx: 10,
          name: "Mexico",
          src: mx,
          code: 521
        },       
    ]

    const { token, wizardData, handleSaveWizardStep } = useAuth();

    const [ showStep3, setShowStep3 ] = useState(true);
    const [ currentFlag, setCurrentFlag ] = useState(flags[0]);
    const [ countries, setCountries ] = useState([]);

    const [ defaultCode, setDefaultCode ] = useState(1)
    const [ defaultCountry, setDefaultCountry ] = useState(null)
    const [ loading, setLoading ] = useState(true)

    const navigate = useNavigate();
    const elRef = useRef(null);

    useEffect(() => {
        if (!token) {
            window.location.href = '/login';
        }

        if (wizardData?.countryId != 6) {
            setShowStep3(false);
        }

        getCountries();
        // console.log("holaW", wizardData)

    }, []);

    useEffect(() => {

        findDefaultCode();
        // console.log(countries)

    }, [countries, defaultCode,defaultCountry]);

    const goToOnboardingThree = (data) => {
        if (showStep3) {
            navigate(`/onboarding-three`)
        } else {
            navigate(`/onboarding-two`)
        }
    }

    const goToOnboardingFive = (data) => {
        navigate(`/onboarding-five`)
    }

    const handleSave = async (data) => {
        const sent = await generateCode(data.telephone);
        if (sent?.ok) {
            data.step = 4;
            if (wizardData?.step) {
                data.step = Math.max(data.step, wizardData.step);
            }
            handleSaveWizardStep(data);
            goToOnboardingFive();
        }
    };

    const generateCode = async (telephone) => {
        let result = false;
        const auxRes = await apiCall(`/api/auth/generate-code`, {telephone}, null, 'POST');
        if (auxRes?.status == 200) {
            // console.log(auxRes);
            result = auxRes.data.data;
        } else {
            toast.error("No se pudo validar el código. Por favor, reintente.");
        }
        return result
    }

    const handleSelect = (flag) => {
        setCurrentFlag(flags[elRef.current.value]);
    }

    const getCountries = async () => {
        const auxRes = await apiCall(`/api/countries`, null, null, 'GET');
        if (auxRes?.status == 200) {
            setCountries(auxRes.data.data);  
        } else {
            toast.error("No se pudo obtener la lista de paises. ERROR: " + auxRes.statusText);
        }

    }

    const findDefaultCode = () => {

        for (let i=0 ; i < countries.length ; i++) {
              if ( countries[i] && countries[i].id == wizardData.countryId) {
                    setDefaultCountry(countries[i].name)
                }
        }
        
        for (let i=0 ; i < flags.length ; i++) {
            if (flags[i] && flags[i].name == defaultCountry) {
                
                setCurrentFlag(flags[i]);
                setDefaultCode(flags[i].idx);
                setLoading(false);
                
                if (elRef.current) {
                    elRef.current.value = defaultCode-1
                }
            }
        }

    }
       

  return (
    <>
    { loading ? <SectionLoading loading={ true } /> : 
    <div className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 font-sans">
        <div className={`w-full max-w-md space-y-8`}>
            <div onClick={ () => goToOnboardingThree() } className="fixed top-[67px] left-[33px]">
                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M7.45711 0.292893C7.84763 0.683418 7.84763 1.31658 7.45711 1.70711L3.16421 6L7.45711 10.2929C7.84763 10.6834 7.84763 11.3166 7.45711 11.7071C7.06658 12.0976 6.43342 12.0976 6.04289 11.7071L1.04289 6.70711C0.855357 6.51957 0.75 6.26522 0.75 6C0.75 5.73478 0.855357 5.48043 1.04289 5.29289L6.04289 0.292893C6.43342 -0.0976311 7.06658 -0.0976311 7.45711 0.292893Z" fill="black"/>
                </svg>
            </div>

            <div className="grid justify-items-center"><img className="mt-[30px]" src={whatsappImage} /></div>

            <div className="font-sans">
                <h2 className="mt-6 text-center text-2xl font-bold tracking-tight text-[#1C1243]">Valida tu Whatsapp</h2>
                <h4 className="mt-4 text-center text-sm font-semibold tracking-tight text-gray-400">Este número es el nexo entre Meducar y tu.</h4>
                <h4 className="text-center text-sm font-semibold tracking-tight text-gray-400">No lo compartiremos con tus pacientes.</h4>
            </div>
            <Formik
                initialValues={{
                    telephone: '',
                }}
                validate={(valores) =>{
                    let errores = {}

                    //const regexEmail = /^(?:(?:00)?549?)?0?(?:11|[2368]\d)(?:(?=\d{0,2}15)\d{2})??\d{8}$/;
                    //TODO: hacer validación bien
                                    

                    // if (!valores.telephone) {
                    //     errores.telephone ='El campo teléfono no puede estar vacío'
                    // } else if (!regexEmail.test(valores.telephone)) {
                    //     errores.telephone ='Debes escribir un teléfono válido'
                    // }

                    return errores;
                }}
                onSubmit={(valores, {resetForm})=>{
                    // resetForm();
                    handleSave({
                        telephone: ""+ currentFlag.code + valores.telephone, 
                    });
                }} 
            >
                {({errors}) => (
                    <Form className="space-y-6" action="#" method="POST">
                        <input type="hidden" name="remember" value="true" />
                                        
                            <div className="my-4">                             
                                <div className="mt-2 flex rounded-2xl shadow-sm mx-4 h-[48px]">
                                    <span className="inline-flex items-center rounded-l-2xl border border-r-0 border-gray-300 py-2 pl-4 text-sm text-gray-500">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M6.4975 4.70231C6.70806 4.63656 6.92696 4.60291 7.14762 4.60291C8.2655 4.60291 9.04932 5.57853 9.04932 6.62344L9.04932 8.58237C9.04932 8.58237 9.04932 8.58237 9.04932 8.58237C9.04932 9.62729 8.2655 10.6029 7.14762 10.6029C7.12608 10.6029 7.10456 10.6026 7.08306 10.6019C7.5955 11.3863 8.26593 12.0567 9.05028 12.5692C9.04964 12.5477 9.04932 12.5261 9.04932 12.5046C9.04932 11.3867 10.0249 10.6029 11.0699 10.6029H13.0288C14.0737 10.6029 15.0493 11.3867 15.0493 12.5046C15.0493 12.7253 15.0157 12.9442 14.9499 13.1547L14.9082 13.2882C14.619 14.2143 13.8003 14.8653 12.8468 15.0333C12.3199 15.1261 11.7787 15.1261 11.2518 15.0333C11.2306 15.0295 11.2094 15.0255 11.1882 15.0213C7.86753 14.382 5.27011 11.7846 4.63089 8.46388C4.62667 8.44279 4.62269 8.42163 4.61895 8.4004C4.52611 7.87353 4.52611 7.33228 4.61895 6.80541C4.78697 5.85191 5.43788 5.03318 6.36397 4.744C6.36398 4.744 6.36397 4.744 6.36397 4.744L6.4975 4.70231ZM6.10304 8.17616C6.10053 8.1631 6.09807 8.15003 6.09563 8.13694C6.03369 7.78326 6.03388 7.41933 6.09619 7.06572C6.17785 6.60232 6.47819 6.27976 6.81106 6.17582L6.94458 6.13413C6.94458 6.13413 6.94459 6.13413 6.94458 6.13413C7.0116 6.11321 7.0798 6.10291 7.14762 6.10291C7.30188 6.10291 7.54932 6.26496 7.54932 6.62343L7.54932 8.58237C7.54932 8.94085 7.30188 9.10291 7.14762 9.10291C7.0798 9.10291 7.0116 9.0926 6.94458 9.07168L6.81106 9.02999C6.4869 8.92877 6.19358 8.62022 6.10304 8.17616ZM11.5152 13.5566C11.8689 13.6185 12.2329 13.6183 12.5865 13.556C13.0499 13.4744 13.3725 13.174 13.4764 12.8412L13.5181 12.7076C13.539 12.6406 13.5493 12.5724 13.5493 12.5046C13.5493 12.3503 13.3873 12.1029 13.0288 12.1029H11.0698C10.7114 12.1029 10.5493 12.3503 10.5493 12.5046C10.5493 12.5724 10.5596 12.6406 10.5805 12.7076C10.5805 12.7076 10.5805 12.7076 10.5805 12.7076L10.6222 12.8412C10.7235 13.1653 11.032 13.4587 11.4761 13.5492C11.4891 13.5517 11.5022 13.5542 11.5152 13.5566Z" fill="#1C1243"/>
                                            <path fillRule="evenodd" clipRule="evenodd" d="M12.6283 2.08306C10.7351 1.63898 8.76488 1.63898 6.87171 2.08306C4.37161 2.6695 2.41951 4.6216 1.83306 7.12171C1.38898 9.01488 1.38898 10.9851 1.83306 12.8783C2.26173 14.7057 1.96091 15.9247 1.71138 16.7769C1.69793 16.8229 1.68518 16.8662 1.67312 16.9072C1.56671 17.2692 1.51462 17.4463 1.50924 17.5953L1.50922 17.5958C1.50677 17.6636 1.50535 17.7031 1.61363 17.8038C1.61556 17.8056 1.61742 17.8074 1.61926 17.8091C1.64615 17.8349 1.66785 17.8556 1.81518 17.8398C1.91309 17.8293 2.03527 17.8038 2.20968 17.7607C2.26042 17.7481 2.31804 17.7334 2.3802 17.7175C2.51066 17.6842 2.66112 17.6458 2.80999 17.6115C3.77302 17.3896 5.09484 17.2337 6.96718 17.9462C8.67239 18.5951 10.6521 18.3805 12.6283 17.9169C15.1284 17.3305 17.0805 15.3784 17.6669 12.8783C18.111 10.9851 18.111 9.01488 17.6669 7.12171C17.0805 4.62161 15.1284 2.6695 12.6283 2.08306ZM6.52916 0.622696C8.64764 0.125768 10.8524 0.125768 12.9708 0.622696C16.0256 1.33924 18.4108 3.72441 19.1273 6.77916C19.6242 8.89764 19.6242 11.1024 19.1273 13.2208C18.4108 16.2756 16.0256 18.6608 12.9708 19.3773C10.9354 19.8548 8.5796 20.1647 6.43369 19.3481C4.90504 18.7664 3.89756 18.9002 3.14678 19.0732C3.01338 19.1039 2.89712 19.1337 2.77798 19.1641C2.71077 19.1813 2.64264 19.1988 2.57 19.2168C2.38576 19.2623 2.18063 19.3091 1.97545 19.3312C1.52665 19.3794 1.0313 19.3108 0.591882 18.902C0.164714 18.5046 -0.00797049 18.0447 0.0102177 17.5412C0.0230103 17.187 0.137673 16.8042 0.232158 16.4888C0.245935 16.4428 0.259284 16.3982 0.271824 16.3554C0.483938 15.631 0.718898 14.6967 0.372699 13.2209C-0.124236 11.1024 -0.12423 8.89763 0.372699 6.77915C1.08925 3.72441 3.47441 1.33924 6.52916 0.622696Z" fill="#1C1243"/>
                                        </svg>
                                        <img className="w-[24px] h-[16px] ml-4" src={ currentFlag.src } />
                                    </span>                                    
                                    <select 
                                        name="country "
                                        className="font-sans max-w-[110px] bg-white flex-1 text-gray-400 text-center border border-l-0 border-r-0 border-gray-300 py-2 text-xs focus:outline-none" 
                                        onChange={() => handleSelect()}
                                        ref={elRef}
                                        //value={defaultCode-1}
                                        >
                                        {flags.map((flag, idx) => (
                                            <option key={flag.idx} value={idx}>
                                                {/* <img className="w-[35px] h-[24px]" style={`background-image:url(${flag.src});`} alt={`Bandera de ${flag.name}`} /> */}
                                                {flag.name}: +{flag.code}
                                            </option>
                                        ))}
                                    </select>
                                    <Field 
                                        type="text" 
                                        name="telephone" 
                                        className="font-sans block w-full flex-1 text-left rounded-r-2xl border border-l-0 border-gray-300 px-3 py-2 text-xl font-semibold focus:outline-none" 
                                    />
                                </div>
                                
                                <ErrorMessage name="telephone" component={() => (
                                    <span className="ml-4 mt-1 text-red-600" >{errors.telephone}</span>
                                )} />
                            </div>                        
                        
                        <div className="w-full bg-white px-4">
                            <button type="submit" className="w-full justify-center rounded-2xl border border-transparent bg-[#3388FF] py-[10px] px-4 text-base font-bold text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">Generar código de validación</button>
                        </div>

                        {/* <div className={`font-sans fixed w-full left-0 bottom-0 flex justify-between mt-0 py-2 px-5 ${classFooter}`}>
                            <div className="pt-[40px] px-2 flex">
                                <div className="w-[8px] h-[8px] bg-[#D1D8DD] rounded-full mr-2"></div>
                                <div className="w-[8px] h-[8px] bg-[#D1D8DD] rounded-full mr-2"></div>
                                { showStep3 && (<div className="w-[8px] h-[8px] bg-[#D1D8DD] rounded-full mr-2"></div>) } 
                                <div className="w-[24px] h-[8px] bg-[#3388FF] rounded-[100px] mr-2"></div>
                                <div className="w-[8px] h-[8px] bg-[#D1D8DD] rounded-full mr-2"></div>
                            </div>
                            <div className="pt-[10px]">
                            <span className="mr-4 text-base text-white font-bold">Siguiente</span>
                            <span>
                                <button type="" className="justify-center rounded-full w-[60px] h-[60px] border border-transparent bg-white py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                                    <svg className="ml-2 font-semibold" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M0.542893 11.7071C0.152369 11.3166 0.152369 10.6834 0.542893 10.2929L4.83579 6L0.542893 1.70711C0.152368 1.31658 0.152368 0.683418 0.542892 0.292894C0.933417 -0.0976309 1.56658 -0.097631 1.95711 0.292894L6.95711 5.29289C7.14464 5.48043 7.25 5.73478 7.25 6C7.25 6.26522 7.14464 6.51957 6.95711 6.70711L1.95711 11.7071C1.56658 12.0976 0.933417 12.0976 0.542893 11.7071Z" fill="white"/>
                                    </svg>
                                </button>
                            </span>
                            </div>
                        </div>  */}

                    </Form>
                )}
            </Formik>
        </div>
    </div>
    }
    
    </>
  )
}